export default __webpack_public_path__ + "static/media/ai72-1-1.5d5f2f5e.jpg";